// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"5086f9d5","508":"4d313e83","776":"62b28d1a"}[chunkId] + ".chunk.js";
};